import {
  EMPLOYEEFACE_LOADING,
  GET_EMPLOYEEFACE,
  GET_EMPLOYEEFACE_SUCCESS,
  GET_EMPLOYEEFACE_FAIL,
  ADD_EMPLOYEEFACE_SUCCESS,
  ADD_EMPLOYEEFACE_FAIL,
  DELETE_EMPLOYEEFACE_SUCCESS,
  DELETE_EMPLOYEEFACE_FAIL,
  UPDATE_EMPLOYEEFACE_SUCCESS,
  UPDATE_EMPLOYEEFACE_FAIL,
  EMPLOYEEFACE_RESET
} from "./actionType";

const INIT_STATE = {
  employeeFaces: [],
  error: {},
};

const EmployeeFace = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EMPLOYEEFACE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_EMPLOYEEFACE:
          return {
            ...state,
            employeeFaces: action.payload.data,
            isEmployeeFaceCreated: false,
            isEmployeeFaceSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_EMPLOYEEFACE_FAIL:
      switch (action.payload.actionType) {
        case GET_EMPLOYEEFACE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isEmployeeFaceCreated: false,
            isEmployeeFaceSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_EMPLOYEEFACE: {
      return {
        ...state,
        isEmployeeFaceCreated: false,
        loading: true,
      };
    }

    case EMPLOYEEFACE_LOADING: {
      return {
        ...state,
        isEmployeeFaceCreated: false,
        loading: true,
      };
    }

    case ADD_EMPLOYEEFACE_SUCCESS:
      return {
        ...state,
        isEmployeeFaceCreated: true,
        loading: false,
        employeeFaces: [action.payload.data, ...state.employeeFaces],
      };

    case ADD_EMPLOYEEFACE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_EMPLOYEEFACE_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeFaces: state.employeeFaces.filter(
          employeeFace => employeeFace.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_EMPLOYEEFACE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_EMPLOYEEFACE_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeFaces: state.employeeFaces.map(employeeFace =>
          employeeFace.id.toString() === action.payload.data.id.toString() ? { ...employeeFace, ...action.payload.data } : employeeFace
        ),
      };

    case UPDATE_EMPLOYEEFACE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case EMPLOYEEFACE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default EmployeeFace;